import axios from 'axios';
import { WITH_CREDENTIALS } from '../utils';

/* the one write that gives a subscription its name, from the card and from the draft's first step */
export const renameList = async (api: string, listId: string, name: string): Promise<void> => {
	await axios.patch(
		`${api}me/lists/${listId}.json`,
		[{ op: 'replace', path: '/name', value: name }],
		WITH_CREDENTIALS
	);
};
